import { render, staticRenderFns } from "./Channel.vue?vue&type=template&id=f2301a9c&scoped=true"
import script from "./Channel.vue?vue&type=script&lang=js"
export * from "./Channel.vue?vue&type=script&lang=js"
import style0 from "./Channel.vue?vue&type=style&index=0&id=f2301a9c&prod&lang=scss&scoped=true"
import style1 from "./Channel.vue?vue&type=style&index=1&id=f2301a9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2301a9c",
  null
  
)

export default component.exports